export const ActionTypes = {
    // SELLING BOOKS
    SELL_BOOKS : "SELL_BOOKS",
    // ADDED TO CART 
    CART_BOOKS : "CART_BOOKS",
    // SELECTED BOOKS
    SELECTED_BOOKS : "SELECTED_BOOKS",
    // WHISTLIST
    WHISTLIST : "WHISTLIST",
    // ONLY THE SELECTED CATAGORY
    CATEGORY: "CATEGORY",
    // ONLY THE SELECTED BOOKS
    POPULARBOOKS : "POPULARBOOKS",
    // NEW USER DATA
    NEWUSER: "NEWUSER",
    // ONLY THE SELECTED CATAGORY
    AUTHOR: "AUTHOR",
    // Al USERS 
    ALLUSER : "ALLUSER",
    // COMMENT_ID
    COMMENTID : "COMMENTID",
    // FOR QUICK VIEW  MODAL OF WEBSITE BOOKS
    QUICKVIEW : "QUICKVIEW",
    // FOR MODAL OF ORDER VIEW
    ORDERVIEW : "ORDERVIEW",
    //  FOR ALL PUBLISHERS ON HOMEPAGE
    ALLPUBLISHER : "ALLPUBLISHER",
    //  FOR ALL BOOKS ON BOOKS ROUTE
    ALLBOOKS : "ALLBOOKS",
    // FOR ALL AUTHORS ON  HOMEPAGE
    ALLAUTHORS : "ALLAUTHORS",
    //  FOR MY ORDERS ON DASHBOARD
    MYORDER : "MYORDER",
    // FOR ALL ORDERS ON DASHBOARD
    ALLORDERS : "ALLORDERS",
    //  FOR MY PROFILE ON DASHBOARD
    MYPROFILE : "MYPROFILE",
    //  FOR ORDER HISTORY ON DASHBOARD
    ORDERHISTORYS : "ORDERHISTORYS",
    //  FOR CURRENT USERS CART  ON  WEBSITE
    CURRENT_CART : "CURRENT_CART",
    //  FOR MY BEST SELLING ON HOMEPAGE
    BEST_SELLING : "BEST_SELLING",
    //  FOR POPULAR BOOKS ON HOMEPAGE
    POPULAR_WRITER_BOOKS : "POPULAR_WRITER_BOOKS",
    //  FOR BEST OFFER BOOKS ON HOMEPAGE
    BEST_OFFER : "BEST_OFFER"

}